module.exports = __webpack_public_path__ + "img/animacao-logo-geon.48d2aa15.gif";